// @flow
/** @jsx jsx */

import GridLayout from '../GridLayout';
import Icon from '../Icon';
import { jsx } from '@emotion/core';

type Props = {
  isDisabled?: boolean,
  isOpen: boolean,
  label?: string,
};

const toggleCss = {
  padding: 10,
};

const Toggle = ({ isDisabled, isOpen, label }: Props) => {
  return (
    <div css={toggleCss}>
      <GridLayout
        alignItems="center"
        columns={label ? '1fr 20px' : '1fr'}
        gap={10}
      >
        <span>{label}</span>
        {!isDisabled && <Icon name={isOpen ? 'arrow-up' : 'arrow-down'} />}
      </GridLayout>
    </div>
  );
};

export default Toggle;
